import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Link2 } from "lucide-react";
import { TextField } from "@/shared/ui/core";
import { FormSection } from "@/features/admin/components";
import { ProductThumb } from "./ProductThumb";
import type { ProductFormValues } from "../productForm";

/**
 * La imagen del producto, POR DIRECCIÓN.
 *
 * Todavía no hay subida de archivos, y fingir que la hay con un botón
 * que no funciona es peor que no tenerla. Se pega la dirección de una
 * imagen que ya está publicada en algún sitio.
 *
 * Valen las DOS formas que acepta el contrato: una dirección completa
 * de otro servidor (`https://…`) o una ruta de este mismo sitio
 * (`/assets/products/detox-elemental.webp`), que es la de las fotos que
 * viajan dentro del repositorio. El texto de ayuda dice las dos porque
 * la segunda no se adivina, y quien administra acabaría pegando una
 * dirección de `localhost` para conseguir lo mismo — que se rompe en
 * cuanto la ve otra persona.
 *
 * La vista previa no es adorno: una URL escrita a mano se equivoca a
 * menudo, y sin previa el error se descubre en la tienda. Si la imagen
 * no carga, `ProductThumb` cae al hueco con icono — que es justo la
 * señal de "esta dirección no sirve".
 */
export function ProductImageField() {
  const { t } = useTranslation();
  const { watch } = useFormContext<ProductFormValues>();
  const imageUrl = watch("imageUrl");

  return (
    <FormSection
      title={t("Imagen principal")}
      /*
        Sin explicación. Decía "pega una dirección completa (https://…) o
        una ruta de este sitio (/assets/…)", que es LETRA POR LETRA lo que
        el hueco del campo ya enseña ("https://… o /assets/products/…").
        Un renglón que repite el de debajo cuesta 30 px en un paso que ya
        se pasa de la pantalla, y no dice nada que no esté a la vista.

        El título pasó a "Imagen principal" a cambio: es lo que ese
        renglón sí aportaba —que ESTA no es una foto más, es la del
        catálogo y la del carrito— y ahora lo dice el título, gratis.
      */
      columns={1}
      compact
    >
      <div className="flex items-start gap-4">
        <ProductThumb
          url={imageUrl?.trim() ? imageUrl : undefined}
          name={t("Vista previa")}
          size="lg"
        />
        <TextField
          name="imageUrl"
          label={t("Dirección de la imagen")}
          icon={<Link2 />}
          inputMode="url"
          autoComplete="off"
          placeholder="https://… o /assets/products/…"
          fieldClassName="flex-1"
        />
      </div>
    </FormSection>
  );
}
